import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  allowedViewsForUser,
  readActiveProductView,
  routeForView,
  viewLabel,
} from "../auth/viewAccess";
import { useAuth } from "../state/AuthProvider";
import { AppThemeToggle } from "../components/AppThemeToggle";
import { FswlPublicBrand } from "../components/BrandLockup";

export function AccountLayout() {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const views = allowedViewsForUser(user);
  const stored = readActiveProductView();
  const returnView =
    stored && views.includes(stored) ? stored : (views[0] ?? "management");

  return (
    <div className="account-shell">
      <header className="account-shell__header">
        <FswlPublicBrand />
        <div className="account-shell__header-actions">
          <AppThemeToggle />
          <button type="button" className="text-button" onClick={() => navigate(routeForView(returnView))}>
            Back to {viewLabel(returnView)}
          </button>
        </div>
      </header>
      <nav className="account-shell__nav" aria-label="Account sections">
        <NavLink to="/account/profile" className={({ isActive }) => (isActive ? "active" : undefined)}>
          Profile
        </NavLink>
        <NavLink to="/account/settings" className={({ isActive }) => (isActive ? "active" : undefined)}>
          Settings
        </NavLink>
        <NavLink to="/account/security" className={({ isActive }) => (isActive ? "active" : undefined)}>
          Security
        </NavLink>
      </nav>
      <main className="account-shell__main">
        <Outlet />
      </main>
    </div>
  );
}

export function AccountProfilePage() {
  const { user } = useAuth();
  if (!user) return null;
  const views = allowedViewsForUser(user);

  return (
    <article className="account-page">
      <h1>My Profile</h1>
      <p className="account-page__lead">Your FSWL account identity and accessible views.</p>
      <dl className="account-details">
        <div>
          <dt>Name</dt>
          <dd>{user.name}</dd>
        </div>
        <div>
          <dt>Email</dt>
          <dd>{user.email}</dd>
        </div>
        <div>
          <dt>Accessible views</dt>
          <dd>{views.map((view) => viewLabel(view)).join(", ")}</dd>
        </div>
      </dl>
    </article>
  );
}

export function AccountSettingsPage() {
  return (
    <article className="account-page">
      <h1>Account Settings</h1>
      <p className="account-page__lead">Personal preferences for your FSWL account.</p>
      <p className="muted">
        Display and notification preferences will expand here. Use the account menu theme controls for
        appearance in the meantime.
      </p>
    </article>
  );
}
